import React from 'react';
import {Link as NativeLink} from 'native-base';
import {message} from './../../utils/messages';

interface Props {
  onPress: () => void;
  label: string;
  mt?: string;
  ml?: string;
  mb?: string;
  color?: string;
  disabled?: boolean;
}

const Link = (props: Props) => {
  const {onPress: handleOnPress, label, mt, ml, mb, color, disabled} = props;
  return (
    <NativeLink
      mt={mt}
      ml={ml}
      mb={mb}
      onPress={disabled ? () => {} : handleOnPress}
      isUnderlined={false}
      _text={{
        color: color ?? 'lightBlue.600',
        opacity: disabled ? 0.3 : 1,
      }}>
      {message(label)}
    </NativeLink>
  );
};

export default Link;
